import offerExTutorialPdf from "./offerExTutorial.pdf";

export const pdfData = {
  offerExTutorialPdf,
};
